<template>

  <div class="dynamic-page">
    <template v-if="header && pageWrapper.header">
      <Header :context="header[0]"></Header>
    </template>

    <section v-if="globalMessages && Array.isArray(globalMessages) && globalMessages.length > 0">
      <v-container fluid>
        <v-row>
          <v-col>
            <Messages :messages="globalMessages"></Messages>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <section id="breadcrumbs" v-if="breadcrumbs">
      <v-container>
        <v-row no-gutters>
          <v-col>
            <bread-crumbs :context="breadcrumbs"/>
          </v-col>
        </v-row>
      </v-container>
    </section>

    <template v-if="loading">
      <v-container class="white dashed-section">
        <v-row>
          <v-col cols="2"></v-col>
          <v-col cols="8" class="py-8">
            <v-skeleton-loader
                type="card-avatar, article, actions, divider,  table-heading, list-item-two-line, image, table-tfoot"
            ></v-skeleton-loader>
          </v-col>
          <v-col cols="2"></v-col>
        </v-row>
      </v-container>
    </template>
    <template v-else-if="specialDisplay">
      <component
          :is="partialDisplay"
          :pageId="pageId"
          :context="rawPageInfo"
          @pageMeta="setPageMeta"
      />

    </template>
    <template v-else>
      <template v-if="body && Array.isArray(body)">
        <template
            v-for="(oneBody, index2) in body"
        >
          <dynamic-section
              :key="index2"
              :context="oneBody"
          />
        </template>
      </template>
    </template>

    <template v-if="footer && pageWrapper.footer">
      <Footer
          :context="footer"
      ></Footer>
    </template>

  </div>

</template>

<script>
import Messages from "@/components/Messages";
import Header from "@/views/template/Header";
import BreadCrumbs from "@/views/template/BreadCrumbs";
import Footer from "@/views/template/Footer";
import DynamicSection from "@/components/DynamicSection";
import globalMixins from "@/mixins/globalMixins";
import specialCTPages from "@/config/specialContentTypePages.json";
import debounce from 'lodash/debounce';

export default {
  name: 'Home',

  mixins: [globalMixins],

  components: {
    BreadCrumbs,
    DynamicSection,
    Header,
    Footer,
    Messages
  },

  data: () => ({
    pageId: 0,
    rawPageInfo: null,
    specialDisplay: false,
    partialDisplay: null,
    loading: true,
    globals: {}
  }),

  props: {
    defaultGlobals: {
      type: Object
    }
  },

  computed: {
    pageWrapper() {
      return {
        header: (process.env.VUE_APP_TYPE && ['website', 'serve'].includes(process.env.VUE_APP_TYPE.toString().toLowerCase())),
        footer: (process.env.VUE_APP_TYPE && ['website', 'serve'].includes(process.env.VUE_APP_TYPE.toString().toLowerCase()))
      }
    }
  },

  async created() {
    this.$meta().setOptions({debounceWait: 50});
    await this.init();
  },

  updated: debounce(function () {
    this.$nextTick(async () => {
      this.getAnchorFromRoute();
      await this.hookAllLinks();
    });
  }, 1000),

  mounted: debounce(function () {
    this.$nextTick(async () => {
      this.getAnchorFromRoute();
      await this.hookAllLinks();
    });
  }, 1000),

  methods: {

    async init() {
      await this.setGlobalDefaults();
      await this.loadData();
    },

    async loadData() {
      this.loading = true;
      let route = (this.$route && this.$route.query && this.$route.query.launch) ? '/' : this.$router.currentRoute.path;
      return this.loadDataInfo(route)
          .then(async (pageInfo) => {
            this.loading = false;
            if (pageInfo && pageInfo.error) {
              let myroute = this.$router.currentRoute.path;
              if ((pageInfo.error === "Access Denied") && (process.env.VUE_APP_TYPE !== "widget")) {

                this.loggedinUser = this.$store.getters['auth/getUser'];
                if (this.loggedinUser) {
                  this.$store.dispatch('auth/clear');
                }

                setTimeout(() => {
                  this.pushMessage({
                    type: 'error',
                    title: pageInfo.error,
                    text: pageInfo.message
                  });
                }, 500);

                this.$router.push({
                  name: "MemberAccess",
                  query: {page: myroute}
                });
                // need to login, or upgrade if he is already logged in

              } else {

                setTimeout(() => {
                  this.pushMessage({
                    type: 'error',
                    title: pageInfo.error,
                    text: pageInfo.message
                  });
                }, 500);

                if ((pageInfo.error === "Page Not Found")) {
                  this.$router.push({name: "error404"});
                } else {
                  this.$router.push({name: "HomePage"});
                }
              }

            } else if (pageInfo) {
              this.resetPage();

              this.pageId = pageInfo.id;
              this.rawPageInfo = pageInfo;

              if (!pageInfo.title || pageInfo.title === "") {
                if (pageInfo.name) {
                  pageInfo.title = pageInfo.name;
                }
              }

              await this.setPageMeta(pageInfo);

              if (pageInfo.sections) {
                this.body = pageInfo.sections;
              }

              this.specialDisplay = false;
              this.partialDisplay = null;

              if (specialCTPages[pageInfo.contentType]) {
                this.specialDisplay = true;
                this.partialDisplay = () => import('../partials/' + specialCTPages[pageInfo.contentType]);
              }
            }
          })
          .catch(error => {
            if (error && error.errors && error.errors[2001]) {
              if (route !== '/') {
                this.$router.push({name: "HomePage"});
              } else {
                this.$router.push({name: 'error404'});
              }
            } else {
              if (process.env.VUE_APP_TYPE === 'widget') {
                if (error && error.errors && error.errors[2005]) {
                  this.loading = false;
                  this.$router.push({name: "HomePage"});
                }
              }
              console.error(error);
            }
          });
    },

    triggerRerenderMenu(updatedMenu) {
      this.$emit('rerenderMenu', updatedMenu);
    }
  },

  watch: {
    async '$route'(to, from) {
      if (to.path !== from.path) {
        await this.init();
      }
    }
  }
}
</script>
<style type="text/css">

.scrollsection {
  max-height: 400px;
  overflow-y: scroll;
  padding-right: 10px;
  padding-left: 10px;
  margin-top: 20px;
  position: relative;
  box-shadow: 0 5px 7px -2px rgba(0, 0, 0, 0.5);
}

/* Show scrollbar even when not scrolling (visible styling) */
.scrollsection::-webkit-scrollbar {
  width: 8px;
}

.scrollsection::-webkit-scrollbar-track {
  background: #f0f0f0;
}

.scrollsection::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 4px;
}

.button-wrapper {
  width: 100%;
  display: block;
  text-align: center;
}

</style>
